import { queryParametersFromString } from '@shared/lib/utils/create-query-parameters/query-parameters-from-string';
import { queryParametersToString } from '@shared/lib/utils/query-parameters-to-string/query-parameters-to-string';
import { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SearchValue } from './type';
import { useRedirect } from '../use-redirect/use-redirect';

export const useModalSearch = (searchKey: string) => {
    const redirect = useRedirect();
    const [modalSearchValue, setModalSearchValue] = useState<SearchValue>(undefined);
    const location = useLocation();

    const handleSetValue = (searchValue?: SearchValue) => {
        const prevSearch = queryParametersFromString(location.search) as Record<string, string | undefined>;
        const newSearch = searchValue ? { [searchKey]: searchValue } : {};
        if (!searchValue) {
            delete prevSearch[searchKey];
        }
        redirect({
            withScrollToTop: false,
            state: { search: queryParametersToString({ ...prevSearch, ...newSearch }) },
        });
    };

    useLayoutEffect(() => {
        const parameters = queryParametersFromString(location.search);
        const searchValue = parameters[searchKey];
        setModalSearchValue(searchValue);
    }, [location.search]);

    return {
        modalSearchValue,
        setModalSearchValue: handleSetValue,
    };
};
